module.exports = __webpack_public_path__ + "img/karriere-weiterbildung-v2.8b837817.jpg";